<template>
  <div class="product-credit-modal">
    <ModalAsideHeader>
      {{ title }}
    </ModalAsideHeader>
    <ModalAsideBody>
      <ProductCredit v-for="credit in items" :key="credit.ID" :result="credit" />
    </ModalAsideBody>
  </div>
</template>

<script lang="ts" setup>
import ModalAsideHeader from '@use/useModalAside/ModalAsideHeader.vue';
import ModalAsideBody from '@use/useModalAside/ModalAsideBody.vue';

import { useStore } from '@/store';
import { computed } from 'vue';
import ProductCredit from '@components/Product/ProductCredit/ProductCredit.vue';

const { state } = useStore();

const paySystem = computed(() => state.product.data?.product?.paySystem);
const items = computed(() => state.product.data?.product?.paySystem.items);
const title = computed(
  () => paySystem.value?.items?.find((el) => el.CODE === 'PRIVATBANK')?.payData?.title
);
</script>

<style lang="scss" scoped>
.product-credit-modal {
}
</style>
